import styled from "styled-components";

export const MemberShadow = styled.div`
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	position: absolute;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	visibility: hidden;

	transition: all 0.2s ease-in-out;

	background-color: rgba(0, 0, 0, 0.4);
`;

export const MemberItem = styled.div`
	margin: 4px;
	position: relative;
	width: 130px;
	height: 130px;
	border-radius: 100px;
	overflow: hidden;

	box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);

	&:hover {
		${MemberShadow} {
			visibility: visible;
		}
	}
`;

export const MemberName = styled.h1`
	margin: 0;
	padding: 0;
	color: white;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: nowrap;
	font-size: 0.8rem;
	font-weight: 500;
`;

export const MemberLinks = styled.div`
	width: 100%;
	margin: 4px 0px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	align-content: center;
	align-self: center;
`;

export const MemberLink = styled.a`
	width: 25px;
	height: 25px;

	margin: 4px;

	text-decoration: none;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	border-radius: 100%;
	background-color: white;

	&:active {
		text-decoration: none;
	}

	box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);
`;